import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../context/LanguageContext';
export function MethodSection() {
  const {
    t
  } = useLanguage();
  const steps = [{
    num: '01',
    title: t('method', 'step1Title'),
    desc: t('method', 'step1Desc')
  }, {
    num: '02',
    title: t('method', 'step2Title'),
    desc: t('method', 'step2Desc')
  }, {
    num: '03',
    title: t('method', 'step3Title'),
    desc: t('method', 'step3Desc')
  }];
  return <section className="py-24 bg-gradient-to-b from-espresso to-charcoal text-white" data-id="element-263">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-264">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-265">
          <h2 className="text-3xl md:text-4xl font-serif font-bold mb-6" data-id="element-266">
            {t('method', 'title')}
          </h2>
          <div className="w-24 h-1 bg-gold mx-auto mb-8" data-id="element-267"></div>
          <p className="text-xl text-white/80 max-w-2xl mx-auto" data-id="element-268">
            {t('method', 'subtitle1')} <br data-id="element-269" />
            <span className="text-gold font-serif text-2xl mt-2 block" data-id="element-270">
              {t('method', 'subtitle2')}
            </span>
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 relative" data-id="element-271">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-12 left-0 w-full h-px bg-gold/30 z-0" data-id="element-272"></div>

          {steps.map((step, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.6,
          delay: index * 0.2
        }} className="relative z-10 bg-espresso/80 backdrop-blur-sm p-6 border border-gold/15 rounded-sm hover:border-gold/40 transition-colors" data-id="element-273">
              <div className="w-16 h-16 bg-gold text-dark rounded-full flex items-center justify-center text-2xl font-serif font-bold mb-6 mx-auto md:mx-0 shadow-lg" data-id="element-274">
                {step.num}
              </div>
              <h3 className="text-xl font-bold mb-4 text-center md:text-left tracking-wide" data-id="element-275">
                {step.title}
              </h3>
              <p className="text-white/70 leading-relaxed text-center md:text-left" data-id="element-276">
                {step.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}